<template>
  <div>
    <v-data-table v-if="items.length > 0" :items="items" :headers="headers">
      <template v-slot:item="props">
        <tr>
          <td
            v-for="(header, index) in headers"
            :key="index"
            :class="all(props.index) ? 'red lighten-1' : propRequired(header.value,props.index)"
          >
            <span>{{ props.item[header.value] }}</span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  props: {
    items: {
      default: () => [],
      type: Array
    },
    properties: {
      default: () => [],
      type: Array
    }
  },
  data: () => ({
    headers: [
      {
        text: "EmpCode",
        value: "empCode",
        sortable: false
      },
      {
        text: "Last Name",
        value: "lastName",
        sortable: false
      },
      {
        text: "First Name",
        value: "firstName",
        sortable: false
      },
      {
        text: "Middlename",
        value: "middleName",
        sortable: false
      },
      {
        text: "Nick Name",
        value: "nickName",
        sortable: false
      },
      {
        text: "House No.",
        value: "houseNum",
        sortable: false
      },
      {
        text: "Street1",
        value: "street1",
        sortable: false
      },
      {
        text: "Street2",
        value: "street2",
        sortable: false
      },
      {
        text: "HCity",
        value: "hCity",
        sortable: false
      },
      {
        text: "Postal Code",
        value: "postalCode",
        sortable: false
      },
      {
        text: "Civil Status",
        value: "civilStatus",
        sortable: false
      },
      {
        text: "Gender",
        value: "gender",
        sortable: false
      },
      {
        text: "Present Phone",
        value: "presentPhone",
        sortable: false
      },
      {
        text: "Mobile Phone",
        value: "mobilePhone",
        sortable: false
      },
      {
        text: "Email",
        value: "email",
        sortable: false
      },
      {
        text: "Birth Date",
        value: "birthDate",
        sortable: false
      },
      {
        text: "Birth Place",
        value: "birthPlace",
        sortable: false
      },
      {
        text: "Emp Status Code",
        value: "empStatCode",
        sortable: false
      },
      {
        text: "Date Hired",
        value: "dateHired",
        sortable: false
      },
      {
        text: "Date Resigned",
        value: "dateResigned",
        sortable: false
      },
      {
        text: "Contract Start",
        value: "contractStart",
        sortable: false
      },
      {
        text: "Contract Ends",
        value: "contractEnds",
        sortable: false
      },
      {
        text: "Duration",
        value: "duration",
        sortable: false
      },
      {
        text: "Contract Amount",
        value: "contractAmount",
        sortable: false
      },
      {
        text: "Salary Type",
        value: "salaryType",
        sortable: false
      },
      {
        text: "Referror",
        value: "referror",
        sortable: false
      },
      {
        text: "Referror",
        value: "immediateSuperior",
        sortable: false
      },
      {
        text: "Emp Code",
        value: "empCode2",
        sortable: false
      },
      {
        text: "Emp Code",
        value: "empCode2",
        sortable: false
      },
      {
        text: "Employee Category",
        value: "empCat",
        sortable: false
      },
      {
        text: "Division Code",
        value: "divCode",
        sortable: false
      },
      {
        text: "Designation Code",
        value: "desCode",
        sortable: false
      },
      {
        text: "Bank Account",
        value: "bankAccount",
        sortable: false
      },
      {
        text: "TIN",
        value: "tin",
        sortable: false
      },
      {
        text: "Movement Type",
        value: "movementType",
        sortable: false
      }
    ]
  }),
  computed: {},
  methods: {
    propRequired(prop, index) {
      var result = this.properties.filter(item => {
        return (
          item.property.toLowerCase() == prop.toLowerCase() &&
          item.index == index
        );
      });

      if (result.length > 0) return "red lighten-1";
      else return "";
    },
    all(index) {
      var result = this.properties.filter(item => {
        return item.property == "ALL" && item.index == index;
      });
      if (result.length > 0) return true;
      else false;
    }
  }
};
</script>